import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import moment from 'moment';

import './Application.css'
import RejectionNotice from '../../components/rejectionNotice'
import { downloadRes, downloadCertificate } from "./api";
const Application = (props) => {

    // Each list is null while loading, [] when there is nothing yet, or
    // 'error' when the request failed — so "you have no certificate" is never
    // shown just because the server did not answer.
    const [certificates, setCertificates] = useState(null)
    const [results, setResults] = useState(null)

    useEffect(() => {
        loadCertificates()
        loadResults()
    }, [])

    // Shown as real links rather than buttons that called window.open after
    // an await: browsers treat a window opened that late as an unrequested
    // pop-up and block it, so the certificate silently failed to open.
    const loadCertificates = async () => {
        const res = await downloadCertificate()
        setCertificates(res?.code === 1 && Array.isArray(res.data) ? res.data : 'error')
    }

    // The endpoint answers code 1 with an empty list when there are no
    // results; that used to open a modal holding an empty table.
    const loadResults = async () => {
        const aadhar = props.auth.auth?.data?.aadhar
        if (!aadhar) return setResults('error')
        const res = await downloadRes(aadhar)
        setResults(res?.code === 1 && Array.isArray(res.data) ? res.data : 'error')
    }

    const fileName = (path) => decodeURIComponent(String(path).split('/').pop())

    return (
        <>
            <div className="card application-box">
                <p className="ui_page_notice">
                    Please read the instructions carefully / सावधानी से निर्देश पढ़ें
                </p>
                <RejectionNotice />

                <div className='application-body row'>
                    <div className='col-md-6'>
                        <div className="card">
                            <div className="card-header card-header-custom">
                                Fill in Your Application
                            </div>
                            <div className="card-body">
                                {/* <h5 className="card-title">Fill in Your Application</h5> */}
                                <p className="card-text">नोट- आप अभ्यास सत्र में सम्मिलित होने के उपरांत या सीधे ही इस बटन को Click कर वास्तविक परीक्षा में शामिल होने के लिए आवेदन पत्र भर सकते हैं।.</p>
                                <Link to="/application-form" className="btn btn-primary"><i className='fa fa-paper-plane'></i> &nbsp;Apply</Link>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="card">
                            <div className="card-header card-header-custom">
                                Practice Exam Slot Booking
                            </div>
                            <div className="card-body">
                                {/* <h5 className="card-title">Practice Exam Slot Booking</h5> */}
                                <p className="card-text">नोट- राजस्व पर्षद के द्वारा परीक्षार्थियों को यह सुविधा प्रदान की जा रही है कि यदि वे चाहें तो किसी भी विषय के लिए वे अभ्यास-सत्र को चुन कर उस विषय के लिए अभ्यास कर सकते हैं। कम्प्यूटर के समक्ष उपस्थित होकर चयनित विषय के Question को हल करेंगे यह कार्य मात्र अभ्यास के लिए है ताकि वें इस नई पद्वति से भलि-भांति अवगत हो जाये।.</p>
                                <Link to="/practice-test" className="btn btn-primary"><i className='fa fa-pencil-alt'></i> &nbsp;Practice</Link>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='application-body row'>
                    <div className='col-md-6'>
                    <div className="card">
                        <div className="card-header card-header-custom">
                            Download your Admit Card
                        </div>
                        <div className="card-body">
                            {/* <h5 className="card-title">Fill in Your Application</h5> */}
                            <p className="card-text">You Can Download Your Admit Card from here</p>
                            <Link to="/admit-card" className="btn btn-primary"><i className='fa fa-download'></i> &nbsp;Download</Link>
                        </div>
                    </div>
                    </div>
                    <div className='col-md-6'>
                    <div className="card">
                        <div className="card-header card-header-custom">
                            View Certificate / Result
                        </div>
                        <div className="card-body">
                            {/* <h5 className="card-title">Practice Exam Slot Booking</h5> */}
                            <div className='docs_group'>
                                <p className='docs_label'>Certificate / प्रमाण-पत्र</p>
                                {certificates === null ? (
                                    <p className='docs_note'>Checking…</p>
                                ) : certificates === 'error' ? (
                                    <p className='docs_note docs_warn'>
                                        Could not load your certificate right now.{' '}
                                        <button type='button' className='docs_retry' onClick={() => { setCertificates(null); loadCertificates() }}>Try again</button>
                                    </p>
                                ) : certificates.length === 0 ? (
                                    <p className='docs_note'>No certificate has been issued yet. It appears here once your result is approved.</p>
                                ) : (
                                    <ul className='docs_list'>
                                        {certificates.map((c) => (
                                            <li key={c.id}>
                                                <a href={process.env.REACT_APP_CERTIFICATE + c.certificate_path} target='_blank' rel='noreferrer' className='docs_link'>
                                                    <i className='fa fa-certificate' aria-hidden='true'></i>
                                                    <span>
                                                        Certificate {c.certificate_number}
                                                        {c.created_at ? <small> · issued {moment(c.created_at).format('DD MMM YYYY')}</small> : null}
                                                    </span>
                                                    <i className='fa fa-external-link-alt docs_link_icon' aria-hidden='true'></i>
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>

                            <div className='docs_group'>
                                <p className='docs_label'>Result / परिणाम</p>
                                {results === null ? (
                                    <p className='docs_note'>Checking…</p>
                                ) : results === 'error' ? (
                                    <p className='docs_note docs_warn'>
                                        Could not load your results right now.{' '}
                                        <button type='button' className='docs_retry' onClick={() => { setResults(null); loadResults() }}>Try again</button>
                                    </p>
                                ) : results.length === 0 ? (
                                    <p className='docs_note'>No result is available yet. Results appear here after your exam.</p>
                                ) : (
                                    <ul className='docs_list'>
                                        {results.map((r, i) => (
                                            <li key={r + i}>
                                                <a href={process.env.REACT_APP_RESULT_URL + r} target='_blank' rel='noreferrer' className='docs_link'>
                                                    <i className='fa fa-file-pdf' aria-hidden='true'></i>
                                                    <span>Result {i + 1} <small>· {fileName(r)}</small></span>
                                                    <i className='fa fa-external-link-alt docs_link_icon' aria-hidden='true'></i>
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        auth: state.Auth
    }
}

export default connect(mapStateToProps)(Application);
